'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enforceValues = exports.setDefaultValues = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDefaultValues = exports.setDefaultValues = (0, _curry2.default)(function (defaults, subject) {
  return (0, _immutable.Map)(defaults).merge(subject);
});

var enforceValues = exports.enforceValues = (0, _curry2.default)(function (valuesToEnforce, subject) {
  return (0, _immutable.Map)(subject).merge(valuesToEnforce);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/lib/propertyValues.js
// module id = 99
// module chunks = 0 1